import { widgetManager } from '../../src/widgetManager/index.js'
import templates from '/app/templates'
import config from '/config/config.js'
import BaseChannel from './base'

export default class GenesysAudioChannel extends BaseChannel {
  constructor(
    settings,
    {
      i18n,
      widgetContainer,
      genesysAudioService,
      texts,
      widgetIndex,
      singleChannelBehavior,
      preInteractionForm,
      validatePreInteractionForm,
      initPreInteractionForm,
      adjustPreInteractionFormConsentsStyles,
    }
  ) {
    super(settings, { widgetContainer })
    this.i18n = i18n
    this.texts = texts
      .filter((x) => x.type === 'audio')
      .reduce(function (map, obj) {
        map[obj.key] = obj.value
        return map
      }, {})
    this.cobrowseTexts = texts
      .filter((x) => x.type === 'cobrowse')
      .reduce(function (map, obj) {
        map[obj.key] = obj.value
        return map
      }, {})
    this.preInteractionFormTexts = texts
      .filter((x) => x.type === 'preInteractionForm')
      .reduce(function (map, obj) {
        map[obj.key] = obj.value
        return map
      }, {})
    this.texts.mobileSettingsLabel = this.texts.mobileSettingsLabel || 'Audio'
    this.fields = settings.fields || []
    this.room

    this.preInteractionForm = preInteractionForm
    this.preInteractionFormEnabled = false
    this.validatePreInteractionForm = validatePreInteractionForm
    this.filerCountriesText = texts.find((x) => x.key === 'filterCountries')?.value || 'Filter countries'
    this.initPreInteractionForm = initPreInteractionForm
    this.adjustPreInteractionFormConsentsStyles = adjustPreInteractionFormConsentsStyles
    this.selectedFormType = ''
    this.preInteractionFormIti = {}

    if (preInteractionForm && Object.keys(preInteractionForm).length > 0) {
      this.preInteractionFormEnabled = preInteractionForm.audio.enabled
    }

    this.sipState = {}
    this.remoteName = window.trueengage.get('audioRemoteName')
    this.cobrowseCode = ''
    this.widgetIndex = widgetIndex
    this.hideInfoTimeout = null

    try {
      this.sipState = {
        accountId: parseInt(widgetContainer.settings.id),
        widgetId: parseInt(widgetContainer.settings.widgets[widgetIndex].id),
        url: location.href,
        visitorId: this.widgetContainer.token,
        gaClientId: this.widgetContainer.googleAnalyticsClientId,
      }
    } catch (e) {
      console.error(e)
    }

    this.activeCall = null
    this.hubConnection = {}

    this.callStats = {
      audio_packets_lost: 0,
      audio_packets_received: 0,
      audio_jitter: 0,
      audio_round_trip_time: 0,
      jitterSum: 0,
      rttSum: 0,
      jitterCount: 0,
      rttCount: 0,
    }

    this.genesysAudioService = genesysAudioService

    this.webRTCinitialized = false
    this.isMobile = this.isMobile()

    this.channelType = 'audio'
    this.singleChannelBehavior = singleChannelBehavior

    this.metrics = {
      packetLoss: 0,
      jitter: 0, // in ms
      rtt: 0, // in ms
    }

    // To track cumulative packet loss and jitter for more accurate assessment
    this.cumulativePacketLoss = 0
    this.cumulativeJitter = 0
    this.rttMeasurements = []
  }

  setup() {
    this.styleNamespace = 'cce-widget-audio'
  }

  isMobile() {
    const isMobile = /iPhone|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && !/iPad/i.test(navigator.userAgent)
    const isPhone = screen.width <= 768
    return isMobile && isPhone
  }

  open() {
    this.$element = document.createElement('div')
    this.$element.classList.add(this.styleNamespace)
    this.render()

    this.removeCoBrowseInfoPanel()

    if (this.isMobile && this.params.mobilePhone != null && this.params.mobilePhone.length > 0) {
      return
    }
    this.getMediaDevices()

    if (!this.webRTCinitialized) {
      this.genesysAudioService.getWebRTCToken({}, (data) => {
        this.initWebRTC(data.token)
      })
    } else {
      if (this.activeCall !== null) {
        this.handleCallUpdate(this.activeCall)
      }
    }
  }

  getMediaDevices() {
    return navigator.mediaDevices.getUserMedia({ audio: true })
  }

  removeCoBrowseInfoPanel() {
    if (this.hideInfoTimeout) {
      clearTimeout(this.hideInfoTimeout) // Kasujemy timer, jeśli istnieje
      this.hideInfoTimeout = null
    }

    var placement = this.widgetContainer.settings.widgets[this.widgetIndex].placement
    const coBrowseWrapper = document.getElementsByClassName(`cce-widget-audio__cobrowse-wrapper-${placement}`)[0]

    if (coBrowseWrapper) {
      coBrowseWrapper.style.display = 'none'
    }
  }

  showCoBrowseInfo() {
    var placement = this.widgetContainer.settings.widgets[this.widgetIndex].placement
    const coBrowseWrapper = document.getElementsByClassName(`cce-widget-audio__cobrowse-wrapper-${placement}`)[0]

    if (coBrowseWrapper) {
      coBrowseWrapper.style.display = 'flex'
    }

    this.hideInfoTimeout = setTimeout(() => {
      this.removeCoBrowseInfoPanel()
    }, 300000)

    document.getElementsByClassName(`${this.styleNamespace}__cobrowse-button-accept`)[0].addEventListener('click', async () => {
      Genesys(
        'command',
        'CobrowseService.acceptSession',
        {
          joinCode: this.cobrowseCode,
        },
        async () => {
          console.log('Co-browse session successfully accepted')
          this.removeCoBrowseInfoPanel()
          await this.hubConnection.invoke('SendCobrowseResult', this.widgetContainer.settings.id, this.widgetContainer.token, 'accepted')
        },
        (err) => {
          console.log('could not accept Co-browse session, error code: ', err.code)
        }
      )
    })

    document.getElementsByClassName(`${this.styleNamespace}__cobrowse-button-reject`)[0].addEventListener('click', async () => {
      await this.hubConnection.invoke('SendCobrowseResult', this.widgetContainer.settings.id, this.widgetContainer.token, 'rejected')

      this.removeCoBrowseInfoPanel()
    })
  }

  initCoBrowse(depylomentId, environment, regionShort) {
    ;(function (g, e, n, es, ys) {
      g['_genesysJs'] = e
      g[e] =
        g[e] ||
        function () {
          ;(g[e].q = g[e].q || []).push(arguments)
        }
      g[e].t = 1 * new Date()
      g[e].c = es
      ys = document.createElement('script')
      ys.async = 1
      ys.src = n
      ys.charset = 'utf-8'
      document.head.appendChild(ys)
    })(window, 'Genesys', `https://apps.${environment}/genesys-bootstrap/genesys.min.js`, {
      environment: regionShort,
      deploymentId: depylomentId,
    })
  }

  initWebRTC(token) {
    return new Promise((resolve, reject) => {
      try {
        let client = new TelnyxWebRTC.TelnyxRTC({ login_token: token })
        client.remoteElement = `${this.styleNamespace}__remoteMedia`
        client.enableMicrophone()

        let settings = this.widgetContainer.settings.widgets[this.widgetIndex].additionalSettings.find((item) => item.key === 'voice_cobrowse')

        const createHubConnection = async () => {
          if (typeof Genesys === 'undefined' && typeof window.Genesys === 'undefined' && settings && settings.value) {
            this.initCoBrowse(settings.deploymentId, settings.environment, settings.regionShort)
          }

          this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(config.interactionHub.host, { withCredentials: false })
            .configureLogging(signalR.LogLevel.Information)
            .build()

          try {
            await this.hubConnection.start({ withCredentials: false })
          } catch (error) {
            return
          }
          await this.hubConnection.invoke('JoinInteractionGroup', this.widgetContainer.settings.id, this.widgetContainer.token)
          this.hubConnection.on('ReceiveCoBrowseOffer', (accountId, visitorId, code) => {
            if (this.widgetContainer.settings.id == accountId && this.widgetContainer.token == visitorId) {
              this.cobrowseCode = code
              this.showCoBrowseInfo()
            }
          })
        }

        //connect to hub only if cobrowse is enabled
        if (settings && settings.value) {
          createHubConnection()
        }

        if (this.isMobile) {
          client.getAudioInDevices().then((devices) => {
            const combobox = this.$element.querySelector(`[name=${this.styleNamespace}__call-settings__mobileSettings]`)
            devices.forEach((device) => {
              let selected = false

              if (device.deviceId === 'communications') {
                this.webRTCClient.setAudioSettings({
                  micId: device.deviceId,
                  micLabel: device.label,
                  deviceId: device.deviceId,
                })
                selected = true
              }
              combobox.add(new Option(device.label, device.deviceId, selected, selected))
            })
          })
        } else {
          client.getAudioOutDevices().then((devices) => {
            const combobox = this.$element.querySelector(`[name=${this.styleNamespace}__call-settings__output]`)
            devices.forEach((device) => {
              let selected = false
              if (device.deviceId === 'default') {
                selected = true
              }
              combobox.add(new Option(device.label, device.deviceId, selected, selected))
            })
          })

          client.getAudioInDevices().then(async (devices) => {
            const combobox = this.$element.querySelector(`[name=${this.styleNamespace}__call-settings__input]`)
            for (const device of devices) {
              let selected = false

              if (device.deviceId === 'communications' || device.deviceId === 'default') {
                await this.webRTCClient.setAudioSettings({
                  micId: device.deviceId,
                  micLabel: device.label,
                  deviceId: device.deviceId,
                })
                selected = true
              }
              combobox.add(new Option(device.label, device.deviceId, selected, selected))
            }
          })
        }

        client
          .on('telnyx.ready', () => {})
          .on('telnyx.error', () => console.log('error'))
          .on('telnyx.notification', (notification) => {
            if (notification.type === 'callUpdate') {
              this.activeCall = notification.call
            }
            this.handleCallUpdate(notification.call)
          })
        client.connect()

        this.webRTCClient = client
        this.webRTCinitialized = true
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  handleCallUpdate(call) {
    let currentCall = call

    switch (call.state) {
      case 'new':
        break
      case 'trying':
        break
      case 'recovering':
        if (confirm('Recover the previous call?')) {
          currentCall.answer()
        } else {
          currentCall.hangup()
        }
        break
      case 'ringing':
        this.playRingtone()
        widgetManager.setWidgetTab('trueengage.audio.ringing')
        break
      case 'active':
        this.widgetContainer.stopRingtone()
        widgetManager.setWidgetTab('trueengage.audio.in-progress')
        break
      case 'hangup':
        this.sendFinalStats()
        currentCall = null
        this.activeCall = null
        this.removeCoBrowseInfoPanel()
        this.triggerPublicEvent('communication_ended', {
          communication_channel: 'audio',
        })
        widgetManager.setWidgetTab('trueengage.audio.completed')
        break
      case 'destroy':
        this.widgetContainer.stopRingtone()
        currentCall = null
        this.activeCall = null
        this.removeCoBrowseInfoPanel()
        break
    }
  }

  render() {
    this.$element.innerHTML = templates.audioTemplate(this.getTemplateVariables())

    if (this.preInteractionFormEnabled) {
      this.$element.innerHTML += templates.preInteractionFormTemplate({
        form: this.preInteractionForm.audio,
        styleNamespace: this.styleNamespace,
        submitButtonText: this.texts.callNow,
        texts: this.preInteractionFormTexts,
        additionalClassname: ``,
        formDataType: 'audio',
      })
    }

    window.liveengage_gc_audio_initialized = true
    this.observeEvents()

    setTimeout(() => {
      if (this.preInteractionFormEnabled) {
        this.preInteractionFormIti.form = this.initPreInteractionForm(
          'audio',
          this.params.defaultCountry || this.widgetContainer.settings.countryCode || DEFAULT_COUNTRY,
          this.filerCountriesText
        )
      }
    }, 0)
  }

  getTemplateVariables() {
    return {
      styleNamespace: this.styleNamespace,
      agreementQuestions: [],
      additionalFields: this.fields || [],
      phone: this.params.phone,
      texts: this.texts,
      isMobile: this.isMobile,
      placement: this.widgetContainer.settings.widgets[this.widgetIndex].placement,
      cobrowseTexts: this.cobrowseTexts,
    }
  }

  startCall() {
    this.widgetContainer.isCallWaitSoundPlaying = true
    this.widgetContainer.playRingtone()

    this.triggerPublicEvent('action_call_start', { channel: 'audio' })

    this.widgetContainer.triggerPublicEvent('widget_business_success', { state: widgetManager.getState(), confirmed: true })
    widgetManager.setWidgetTab('trueengage.audio.ringing')

    this.remoteName = window.trueengage.get('audioRemoteName')

    let customAttributes = window.trueengage.get('customAttributes') || {}
    Object.assign(this.sipState, customAttributes)

    let call = this.webRTCClient.newCall({
      destinationNumber: this.params.phone,
      callerName: this.remoteName,
      video: false,
      clientState: btoa(JSON.stringify(this.sipState)),
    })

    call.getStats((stats) => {
      this.processStat(stats)
    }, {})
  }

  processStat(stat) {
    switch (stat.type) {
      case 'inbound-rtp':
        if (stat.kind === 'audio') {
          this.callStats.audio_packets_lost += stat.packetsLost
          this.callStats.audio_packets_received += stat.packetsReceived
          if (stat.jitter !== undefined) {
            this.callStats.jitterSum += stat.jitter * 1000 // w ms
            this.callStats.jitterCount++
          }
        }
        break
      case 'candidate-pair':
        if (stat.nominated && stat.state === 'succeeded') {
          if (stat.currentRoundTripTime !== undefined) {
            const rttMs = stat.currentRoundTripTime * 1000 // w ms
            this.callStats.rttSum += rttMs
            this.callStats.rttCount++
          }
        }
        break
      default:
        break
    }
  }

  calculateFinalStats() {
    // Obliczanie średniego jittera i RTT
    this.callStats.audio_jitter = this.callStats.jitterCount > 0 ? this.callStats.jitterSum / this.callStats.jitterCount : 0
    this.callStats.audio_round_trip_time = this.callStats.rttCount > 0 ? this.callStats.rttSum / this.callStats.rttCount : 0

    return {
      session_id: this.activeCall.session.uuid,
      visitor_id: this.widgetContainer.token,
      audio_packets_lost: this.callStats.audio_packets_lost,
      audio_packets_received: this.callStats.audio_packets_received,
      audio_jitter: this.callStats.audio_jitter,
      audio_round_trip_time: this.callStats.audio_round_trip_time,
    }
  }

  sendFinalStats() {
    const webrtcStats = this.calculateFinalStats()
    this.widgetContainer.statisticsService.sendWebRTCStats(webrtcStats)
  }

  hangupCall() {
    if (this.activeCall !== null) {
      this.activeCall.hangup()
    }
    this.removeCoBrowseInfoPanel()
  }

  toggleMute() {
    let elem = this.$element.querySelector(`#${this.styleNamespace}__mute`)
    elem.classList.toggle('muted')

    if (this.activeCall !== null) {
      this.activeCall.toggleAudioMute()
    }
  }

  async setAudioInDevice(deviceId, deviceLabel) {
    if (this.activeCall !== null) {
      await this.activeCall.setAudioInDevice(deviceId)
    }

    this.webRTCClient.setAudioSettings({
      micId: deviceId,
      micLabel: deviceLabel,
      deviceId: deviceId,
    })
  }

  async setAudioOutDevice(deviceId) {
    if (this.activeCall !== null) {
      await this.activeCall.setAudioOutDevice(deviceId)
    }
    this.webRTCClient.speaker = deviceId
  }

  handleDialInputChange() {
    this.widgetContainer.playZipSound()
  }

  observeEvents() {
    this.$element.querySelector(`#${this.styleNamespace}__mute`).addEventListener('click', (_) => {
      this.toggleMute()
    })

    this.$element.querySelector(`#${this.styleNamespace}__settings-back`).addEventListener('click', (_) => {
      widgetManager.setWidgetTab(widgetManager.getPreviousWidgetTab())
    })

    this.$element.querySelectorAll(`.${this.styleNamespace}__settings-button`).forEach((elem) => {
      elem.addEventListener('click', () => {
        widgetManager.setWidgetTab('trueengage.audio.settings')
      })
    })

    this.$element
      .querySelector(`.${this.styleNamespace}__dial-back button`)
      .addEventListener('click', () => widgetManager.setWidgetTab(widgetManager.getPreviousWidgetTab()))

    this.$element.querySelector(`.${this.styleNamespace}__dial-button`).addEventListener('click', () => widgetManager.setWidgetTab('trueengage.audio.dial'))

    this.$element.querySelectorAll(`.${this.styleNamespace}__dial-item`).forEach((elem) =>
      elem.addEventListener('click', (_) => {
        const value = elem.textContent.trim()
        document.querySelector(`.${this.styleNamespace}__dial-input input`).value += value
        this.activeCall.dtmf(value)
        this.handleDialInputChange(value)
      })
    )

    this.$element.querySelector(`#${this.styleNamespace}__call-audio`).addEventListener('click', () => {
      const isMobilePhoneAvailable = this.params.mobilePhone?.length > 0

      if (this.isMobile && isMobilePhoneAvailable) {
        window.location.href = `tel:${this.params.mobilePhone}`
        return
      }

      if (this.preInteractionFormEnabled) {
        widgetManager.setWidgetTab('trueengage.audio.pre-interaction-form')
        this.adjustPreInteractionFormConsentsStyles('audio')
        return
      }

      this.startCall()
    })

    this.$element.querySelector(`#${this.styleNamespace}__hangup`).addEventListener('click', (_) => {
      this.hangupCall()
    })

    this.$element.querySelectorAll(`.${this.styleNamespace}__call-settings__device`).forEach((input) =>
      input.addEventListener('change', (select) => {
        const element = select.target
        const deviceId = element.value
        const deviceLabel = element.textContent
        const direction = element.dataset.dir

        if (direction === 'mobileSettings') {
          this.setAudioInDevice(deviceId, deviceLabel)
          this.setAudioOutDevice(deviceId, deviceLabel)
        } else if (direction === 'input') {
          this.setAudioInDevice(deviceId, deviceLabel)
        } else if (direction === 'output') {
          this.setAudioOutDevice(deviceId, deviceLabel)
        }
      })
    )

    this.$element.querySelector('form').addEventListener('submit', (e) => {
      e.preventDefault()
      e.stopPropagation()
    })

    this.$element.querySelector(`#${this.styleNamespace}__close`).addEventListener('click', () => {
      this.widgetContainer.stopRingtone()
      if (this.singleChannelBehavior === 'open_channel' && this.widgetContainer.settings.widgets[this.widgetIndex].channels.length === 1) {
        widgetManager.setWidgetTab('trueengage.audio')
        widgetManager.closeWidget()
      } else {
        widgetManager.setWidgetTab('trueengage.channel_picker')
      }
    })

    if (this.preInteractionFormEnabled) {
      this.$element.querySelector(`.${this.styleNamespace}__pre-interaction-form`).addEventListener('submit', (event) => {
        event.preventDefault()
        event.stopPropagation()

        let formData = new FormData(event.target)

        let formValues = Object.fromEntries(formData.entries())
        if (!this.validatePreInteractionForm('audio', this.preInteractionFormIti.form, this.preInteractionFormTexts)) return
        Object.keys(formValues).forEach((key) => {
          if (key.startsWith('consents[')) {
            delete formValues[key]
          }
        })

        event.target.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
          let match = checkbox.name.match(/^consents\[(.+)\]$/)
          if (match) {
            if (!formValues.consents) formValues.consents = {}
            formValues.consents[match[1]] = checkbox.checked
          }
        })

        if (this.preInteractionFormIti.form) {
          formValues.phoneNumber = this.preInteractionFormIti.form.getNumber()
        }

        this.sipState.trueengage_form = formValues

        this.startCall()
        const headerElement = document.querySelector('.cce-widget__window__header')
        headerElement.classList.remove('cce-widget__window--with-pre-interaction-form')
      })
    }
  }
}
